export default __webpack_public_path__ + "static/media/017-librarian.1c377c24.svg";